import React from 'react'
import "../Puneprices/Puneprice.css"; 
import { Pricecard } from '../Pricecard/Pricecard.jsx';

export default function Puneprice() {
  return (
    <>
        <div className="Puneprice">
          <div className="container-fluid">
            <div className="container">
                <h1 className='text-center Puneprice_title'>PRICING <span className="green">PUNE</span></h1>
                <div className="mx-auto border-3 title-border-bottom w-50"></div>
              <div className="row Puneprice_Outer pt-4">
                <div className="col-12 col-md-6 Puneprice_card g-5">
                    <Pricecard
                        packagesName="Single Session"
                        packagePrice="799/-"
                        pkalistpoint1="Daily Online Payment"
                        pkalistpoint2="Session: Upto 45 Minutes"
                        pkalistpoint3="For Single Session"
                        pkalistpoint4="Alternate Session"
                        packagesLink="/about"
                        pkabuttonText="BOOK NOW"
                        
                    />
                </div>
                <div className="col-12 col-md-6 Puneprice_card g-5">
                    <Pricecard
                        packagesName="7 Days Package"
                        packagePrice="5250/-"
                        pkalistpoint1="Advance Online Payment"
                        pkalistpoint2="Session: Upto 45 Minutes"
                        pkalistpoint3="For 7 Session"
                        pkalistpoint4="No Alternate Session"
                        packagesLink="/about"
                        pkabuttonText="BOOK NOW"
                        
                    />
                </div>
                <div className="col-12 col-md-6 Puneprice_card g-5">
                    <Pricecard
                        packagesName="15 Days Package"
                        packagePrice="10500/-"
                        pkalistpoint1="Advance Online Payment"
                        pkalistpoint2="Session: Upto 45 Minutes"
                        pkalistpoint3="For 15 Session"
                        pkalistpoint4="No Alternate Session"
                        packagesLink="/about"
                        pkabuttonText="BOOK NOW"
                        
                    />
                </div>
                <div className="col-12 col-md-6 Puneprice_card g-5">
                    <Pricecard
                        packagesName="30 Days Package"
                        packagePrice="19500/-"
                        pkalistpoint1="Advance Online Payment"
                        pkalistpoint2="Session: Upto 45 Minutes"
                        pkalistpoint3="For 30 Session"
                        pkalistpoint4="No Alternate Session"
                        packagesLink="/about"
                        pkabuttonText="BOOK NOW"
                        
                    />
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  )
}
